<template>
  <div id="sidebar" :class="(item.youtube_code != '' ? 'has_video' : '')" :key="user.id">

    <div v-if="item.album_type_parsed != ''" id="type_tag"><span v-text="item.album_type_parsed"></span></div>

    <div class="header">

      <a @click="$emit('open_share')"><i class="fa fa-share-alt"></i><span>שתף</span></a>
      <a v-if="item.is_more_artist == 1" :href="item.artist.link" target="_blank"><i class="fas fa-user"></i><span>עוד מהאמן</span></a>
      <a v-if="is_logged && item.is_favorite" @click="remove_fav()"><i class="fas fa-heart"></i><span>הסרה מאהבתי</span></a>
      <a v-if="is_logged && !item.is_favorite" @click="add_fav()"><i class="far fa-heart"></i><span>אהבתי</span></a>

    </div>


    <div class="song-info text-center">
        <h2 class="singer-name" v-text="item.artist.name"></h2>
        <p class="song-name" v-text="item.name"></p>
        <div v-if="musicSrc !=''">
          <p v-if="song_duration > 0" style="font-size:13px; margin-top:-8px; margin-bottom:10px;">{{format_dur(currentTime)}} / {{format_dur(song_duration)}}</p>
          <p v-else style="font-size:13px; margin-top:-8px; margin-bottom:10px;" v-text="item.time_parsed"></p>
        </div>


    </div>

<div  v-if="item.artist.pic_tumb != null" id="player_slider_wrap" :style="'background-image:url(' + item.artist.pic_tumb + ')'" >
  <div v-if="song_duration>0">
<circle-slider :key="song_duration"
  v-model="player_curr_time"
  :side="(is_mobile() ? 100 : 200)"
  :min="0"
  :max="song_duration"
  :step-size="1"
  :circle-width-rel="60"
  :progress-width-rel="40"
  :knob-radius="7"
  :knob-color="'#' + item.color"
  :progress-color="'#' + item.color"
></circle-slider>
</div>
</div>

<audio :src="musicSrc" preload="auto" ref="audioplayer" @timeupdate="onTimeUpdate" @ended="onEnded">
  <p>Your browser does not support the <code>audio</code> element.</p>
</audio>
<div v-if="musicSrc !=''">
  <div id="player_buttons">
    <a @click="play()" class="play_btn" v-show="player && !is_playing"><i class="fa fa-play-circle"></i></a>
    <a @click="stop()" class="play_btn" v-show="player && is_playing"><i class="fa fa-pause-circle"></i></a>

    <a @click="change_volume(1)" v-show="!is_mobile() && player && player.volume == 0"><i class="volume_btn fa fa-volume-off"></i></a>
    <a @click="change_volume(0)" v-show="!is_mobile() && player && player.volume > 0"><i class="volume_btn fa fa-volume-up"></i></a>

    <span class="song-volume-slider temp3-volume-controller" v-if="!is_mobile() && player" :key="player"><input class="" type="range" id="volume_control" min="0" max="1" value="1" step=".1" v-model="player.volume"></span>

  </div>
</div>
    <ul v-if="(item.songs.length > 1)">
      <li  v-for="(song, index) in item.songs" :key="song.id" :class="(song.mp3_url==musicSrc ? 'active' : '')" :data-songurl="song.mp3_url" @click="stop(); musicSrc=song.mp3_url; play()">
        <span v-text="(item.songs.length > 1 ? (index+1) + '. ' : '') + song.name"></span>
        
        <a v-if="user || item.allow_anonymous_download == '1'" :href="'https://www.mysong.co.il/download/song?sid=' + song.id"><i class="fa fa-download"></i></a>
        <a v-else @click="$emit('open_login_pop')"><i class="fa fa-download"></i></a>
      </li>
    </ul>
    <div v-if="item.is_hompage_in_sidebar == 1" id="is_hompage_in_sidebar" :class="item.sticker ? 'has_text' : '' "  v-html="item.sticker">
    </div>
    <div class="clip-floating" id="clip-floating" v-if="item.youtube_code != '' && !is_mobile()">
      <div class="iframe-holder">
        <iframe :src="'https://www.youtube.com/embed/' + item.youtube_code + '?enablejsapi=1&amp;autoplay=1'" frameborder="0" allow="encrypted-media" allowfullscreen="" id="youtubeiframeid"></iframe>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ["item", "user"],
  data() {
    return {
      player: null,
      musicSrc: '',
      song_duration: 0,
      currentTime: 0,
    }
  },
  methods: { 
    play() {
      setTimeout(() => {
        this.player.play();
        this.song_duration = this.player.duration;  
      }, 300);
      
    },
    pause() {
      this.player.pause();
    },
    stop() {
      this.player.pause();
    },
    onTimeUpdate () {
     this.currentTime = this.player.currentTime
     
    },
    onEnded () {
      let PlayNext = false;
      for (let i in this.item.songs)
      {
        if (PlayNext)
        {
          this.musicSrc=this.item.songs[i].mp3_url; 
          this.play()
          break;
        }
        
        if (this.item.songs[i].mp3_url == this.musicSrc)
        {
          PlayNext = true;
        }
      }

      
     
    },
    change_volume(vol)
    {
      this.player.volume = vol;
    }, 
    play_by_id(id)
    {
      this.stop(); 

      for (let i in this.item.songs)
      {
        if (this.item.songs[i].id == id)
        {
          
      this.musicSrc=this.item.songs[i].mp3_url; 
      this.play()
          break;
        }
      }

    },

    add_fav()
    {
      this.item.is_favorite = true; 
      this.$http.post(window.api_url + 'favorites/add', {id:  this.item.id}).then(function(){
      });

    },

    remove_fav()
    {
      this.item.is_favorite = false; 
      this.$http.post(window.api_url + 'favorites/remove', {id:  this.item.id}).then(function(){
        
      });
    },

    format_dur(dur) 
    {
        var sec_num = parseInt(dur, 10);
        var hours   = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);

        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        return /*hours+':'+*/minutes+':'+seconds;
    }

    
  },
  computed: {
    is_logged(){

      if (this.user)
      { 
      return (this.user.id > 0);
      }
      return false;
    },


    player_curr_time: {
      cache: false,
      // getter
      get: function () {
        //if (this.player == null || this.play == undefined) return 0;
        //return this.player.currentTime;
        return this.currentTime;
      },
      // setter
      set: function (newValue) {
        if ( (newValue > (this.currentTime + 1) ) || (newValue < (this.currentTime - 1) ) ) this.player.currentTime = newValue;
        //console.log(newValue)
        //this.play();
        //return newValue;
        //this.player.currentTime = newValue;
      }
    },
    url_parsed(){
      return 'blat';
    },
    is_playing: {
      cache: false,
      get: function () {
       
        return (!this.player.paused && this.player.currentTime > 0 && !this.player.ended);
      },
    },
  },
  mounted () {
    this.player = this.$refs.audioplayer;
    this.musicSrc = this.item.songs[0].mp3_url;
  },


}
</script>